var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[(true)?_c('MenuLanding'):_vm._e(),_c('div',{staticClass:"page-container"},[_c('RouterView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }